export default {"src":"/_next/static/media/bookings.895bec6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};